module.exports = __webpack_public_path__ + "static/media/logo.987a6b45.svg";